// src/components/Popup.js

import React from 'react';
import './AdminCSS/adminupdate.css'; // Import the CSS file


const AdminUpdate = ({ formData, setFormData, handleUpdateSubmit, setSelectedAdmin }) => {
  return (
    <div className="popup-admin">
      <h3>Update Admin</h3>
      <label htmlFor="user_name">User Name:</label>
      <input 
        type="text" 
        value={formData.user_name} 
        onChange={(e) => setFormData({ ...formData, user_name: e.target.value })} 
        placeholder="User Name" 
      />

      <label htmlFor="email">Email:</label>
      <input 
        type="email" 
        value={formData.email} 
        onChange={(e) => setFormData({ ...formData, email: e.target.value })} 
        placeholder="Email" 
      />

      <label htmlFor="password">Password:</label>
        <input 
        type="password" 
        value={formData.password} 
        onChange={(e) => setFormData({ ...formData, password: e.target.value })} 
        placeholder="password" 
      />
      <button onClick={handleUpdateSubmit}>Submit</button>
      <button onClick={() => setSelectedAdmin(null)}>Cancel</button>
    </div>
  );
};

export default AdminUpdate;
